export default "__VITE_ASSET__C4mjo1fF__"